import React from 'react';
import Icon from './Icon';

const initials = (name = '') => name.split(' ').map((p) => p[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();

/** TestimonialCard — avatar (or initials), name, place, quote, star rating. */
export default function TestimonialCard({ name, place, text, rating = 5, avatar, className = '' }) {
  return (
    <figure className={`card testimonial${className ? ` ${className}` : ''}`}>
      <div className="testimonial__head">
        {avatar ? (
          <img className="testimonial__avatar" src={avatar} alt="" loading="lazy" />
        ) : (
          <span className="testimonial__avatar testimonial__avatar--initials" aria-hidden="true">{initials(name)}</span>
        )}
        <figcaption>
          <div className="testimonial__name">{name}</div>
          {place && <div className="testimonial__place">{place}</div>}
        </figcaption>
        <Icon name="quote" size={22} className="testimonial__quote" />
      </div>
      <blockquote className="testimonial__text">{text}</blockquote>
      <div className="testimonial__stars" aria-label={`${rating} out of 5 stars`}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Icon key={i} name="star" size={14} strokeWidth={0} className={i < rating ? 'is-on' : ''} />
        ))}
      </div>
    </figure>
  );
}
